import React from 'react';
import { useLocation } from 'react-router-dom';

import { IonContent, IonPage } from '@ionic/react';

import DesktopHeader from './DesktopHeader';

import './styles/desktop.js';

const DesktopLayout = ({ children, fpsConfigs, options, hasPromotionPosts, promotionsNumber }) => {
  const location = useLocation();
  const isHomePage = location.pathname === '/app/home';

  return (
    <IonPage className="desktop-layout">
      <DesktopHeader fpsConfigs={fpsConfigs} options={options} hasPromotionPosts={hasPromotionPosts} promotionsNumber={promotionsNumber} />
      <IonContent className="desktop-content">
        <div className={`desktop-container${isHomePage ? ' desktop-homepage-wrapper' : ''}`}>{children}</div>
      </IonContent>
    </IonPage>
  );
};

export default DesktopLayout;
